'use client'

import { useEffect, useRef, useState } from 'react'
import { CheckCircle } from './Icons'

/**
 * Bar Council of India waala disclaimer — purane Default.aspx ka #myModal.
 * Text bilkul wahi hai, ek shabd nahi badla.
 *
 * Purana site par ye har baar Default.aspx khulte hi dikhta tha (bootstrap 3 ka
 * `.modal(options)` default `show: true` ke saath chalta hai), isliye yahan bhi
 * wahi rakha hai — home page har load/refresh par ise dikhata hai.
 *
 * `useState(true)` jaan-boojh kar hai: server aur client dono ka pehla render
 * ek jaisa hota hai (koi hydration mismatch nahi) aur modal seedha HTML me hi
 * aa jaata hai — page pehle dikh kar phir modal "kood" kar nahi aata.
 */
export default function DisclaimerModal() {
  const [open, setOpen] = useState(true)
  const panel = useRef<HTMLDivElement>(null)

  /*
   * Focus button par nahi, poore dialog par jaata hai.
   *
   * Pehle button par autoFocus tha — screen reader ke liye theek, par Chrome
   * usay :focus-visible maan kar uske chaaron taraf gold ring khींch deta tha,
   * jo gold button par doosri border jaisi dikhti thi. Dialog par focus dene se
   * screen reader poora disclaimer padh deta hai (aur wahi zyada sahi bhi hai —
   * user ko "I Agree" se pehle text milna chahiye), aur ring kahin nahi aati.
   */
  useEffect(() => {
    if (open) panel.current?.focus()
  }, [open])

  // modal khula ho to background scroll band
  useEffect(() => {
    if (!open) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [open])

  function accept() {
    setOpen(false)
  }

  if (!open) return null

  return (
    <div
      className="dialog-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disclaimer-title"
    >
      {/* Backdrop click par band nahi hota — user ko "I Agree" dabana hi hoga,
          jaise purane modal me backdrop:'static' aur keyboard:false tha. */}
      <div className="dialog dialog--wide" ref={panel} tabIndex={-1}>
        <h2 className="dialog__title" id="disclaimer-title">
          Disclaimer &amp; Confirmation
        </h2>
        {/* wahi gold rule jo site ki har heading ke neeche aati hai */}
        <div className="rule rule--center" />

        <div className="dialog__body">
          <p>
            As per the rules of the Bar council of India, we are not permitted to solicit
            work and advertise. By clicking on the &quot;I Agree&quot; below, the user
            acknowledges the following:
          </p>
          <p>
            1. There has been no advertisement, personal communication, solicitation,
            invitation or inducement of any sort whatsoever from us or any of our members
            to solicit any work through this website;
          </p>
          <p>
            2. The users wishes to gain more information about us for his/her own
            information and use.
          </p>
          <p>
            3. The information about us is provided to the user only on his/her specific
            request and any information obtained or materials downloaded from this website
            is completely at the user&apos;s violation and any transmission, receipt or use
            of this site would not create any lawyer-client relationship.
          </p>
          <p>
            The information provided under this website is solely available at your request
            for informational purpose only, should not be interpreted as soliciting or
            advertisement. We are not liable for any consequence of any action taken by the
            user relying on material/information provided under this website. In case where
            the user has any legal issues, he/she in all cases must seek independent legal
            advice.
          </p>
        </div>

        <div className="dialog__actions">
          <button type="button" className="btn btn--gold" onClick={accept}>
            <CheckCircle size={18} />
            I Agree
          </button>
        </div>
      </div>
    </div>
  )
}
